import { FC } from 'react';
import ReactMarkdown from 'react-markdown';

import Link from '../Link';
import { MarkdownMessageContentRoot } from './styles';

interface MarkdownMessageContentProps {
    children: string;
}

const ALLOWED_MARKDOWN_ELEMENTS = [
    'a',
    'blockquote',
    'br',
    'code',
    'em',
    'li',
    'ol',
    'p',
    'pre',
    'strong',
    'ul',
];

const MarkdownMessageContent: FC<MarkdownMessageContentProps> = ({ children }) => (
    <MarkdownMessageContentRoot>
        <ReactMarkdown
            allowedElements={ALLOWED_MARKDOWN_ELEMENTS}
            skipHtml
            unwrapDisallowed
            components={{
                a: ({ href, children: linkChildren }) => (
                    <Link href={href} rel="noopener noreferrer" target="_blank">
                        {linkChildren}
                    </Link>
                ),
            }}
        >
            {children}
        </ReactMarkdown>
    </MarkdownMessageContentRoot>
);

export default MarkdownMessageContent;
